/** @jsx jsx */
import { Box, Heading, jsx } from 'theme-ui'
import LineItem from '~/components/Cart/LineItem'
import VisuallyHidden from '~/components/Generic/VisuallyHidden'

const LineItems = ({
  items = [],
  linkProducts = true,
  orderConfirmed = false,
}) => {
  return (
    <Box>
      <VisuallyHidden>
        <Heading as="h3" mt={2}>
          {'Shopping cart items'}
        </Heading>
      </VisuallyHidden>
      {items
        .filter((lineItem) => !lineItem.variant.hidden)
        .map((lineItem, index) => (
          <Box
            key={`cart-line-item-${index}`}
            py={orderConfirmed ? 3 : 2}
            sx={{
              borderBottom: '1px solid',
              borderBottomColor: 'greyLight',
            }}
          >
            <LineItem
              lineItem={lineItem}
              linkProduct={linkProducts}
              orderConfirmed={orderConfirmed}
            />
          </Box>
        ))}
    </Box>
  )
}

export default LineItems
